export const DICT_SESSION_PREFIX = 'Z__DICT__SESSION__'
